import { useStore } from '@tanstack/react-form'
import { routes } from 'commons/constants/routes'
import { ButtonGroup } from 'ui/components/ButtonGroup'
import { Button } from 'ui/components/Buttons'
import { useTemplateManageContext } from '~bank-document-templates/manage/context'

import { s } from './styles'

export const Footer = () => {
  const { formApi, routeApi, data } = useTemplateManageContext()

  const isSubmitting = useStore(formApi.store, (s) => s.isSubmitting)
  const {
    form: { id }
  } = data
  const navigate = routeApi.useNavigate()

  const onCancel = () => {
    id
      ? navigate({ to: routes.bank.documentTemplates.details, params: { id: id.toString() } })
      : navigate({ to: routes.bank.documentTemplates.index })
  }

  return (
    <s.Box>
      <ButtonGroup margin="small">
        <Button face="secondary" onClick={onCancel} data-qa="Cancel">
          Cancel
        </Button>
        <Button loading={isSubmitting} onClick={formApi.handleSubmit} face="primary" data-qa="Save">
          {id === 0 ? 'Create template' : 'Save'}
        </Button>
      </ButtonGroup>
    </s.Box>
  )
}
